import { Component, Input, forwardRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { CompanyService }    from '../companies/company.service';
import { MessagesService }   from '../messages/messages.service';
import { UKPostcodeService } from './uk-postcode.service';

@Component({
  selector   : 'wor-uk-postcode-settings',
  template: require('./uk-postcode.settings.component.html')
})
export class UKPostcodeSettingsComponent {
  @Input() availableRequests: number;

  constructor (
    @Inject(forwardRef(() => CompanyService))
    public  companyService   : CompanyService,
    @Inject(forwardRef(() => MessagesService)) private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService,
    @Inject(forwardRef(() => UKPostcodeService)) private ukPostcodeService: UKPostcodeService
  ) {}

  activate () : void {
    this.ukPostcodeService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.ukPostcodeService.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.ukPostcodeService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: this.ukPostcodeService.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  purchase () : void {
    this.ukPostcodeService.purchase();
  }
}
